<template>
  <div>
    <div class="row justify-content-between align-items-center">
      <div class="col-md-9 customHeading">
        <h3>{{ moduleName }}</h3>
      </div>

      <!--==========Class dropdown============-->

      <!---SEARCH BOX-->
      <div class="col-md-2">
        <div class="searchbox input-group" role="group">
          <input
            class="form-control search-box my-search-box"
            type="text"
            placeholder="Name"
            aria-label="search"
            v-model="filteredText"
          />

          <button
            class="search-button btn btn-primary filter"
            @click="getBrands()"
          >
            <i class="fa fa-search search-icon"></i>
          </button>
        </div>
      </div>
      <div class="col-md-1 Add-button" style="text-align: center">
        <a href="javascript:void(0)">
          <div class="AddButton">
            <div class="icon">
              <i
                class="fas fa-arrow-alt-circle-right fa-1x"
                style="color: rgb(255, 50, 55)"
              >
              </i>
            </div>
            <div data-text="Add" class="name add-btn" v-b-modal.AddBrandModal>
              Add
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr
          color="#CACACA"
          style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px"
        />
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col">
          <table
            class="
              table table-striped table-borderless
              cutom-table
              table-striped table-sm
            "
            style="font-size: 85%"
          >
            <thead>
              <tr>
                <th role="columnheader">Title</th>
                <th role="columnheader">Link</th>
                <th role="columnheader">Image</th>
                <th role="columnheader">Is Featured</th>
                <th role="columnheader">Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if="brands == null">
                <td class="center-td" colspan="5">No Data</td>
              </tr>

              <tr v-else v-for="(record, index) in brands" :key="index">
                <td role="cell">{{ record.brandName }}</td>

                <td role="cell">
                  <a :href="record.brandUrl" target="_blank"
                    ><i class="fas fa-globe-asia"></i
                  ></a>
                </td>
                <td role="cell">
                  <!-- <a
                    href="'https://smw.demo.itrooscloud.net/' + record.brandImage"
                    target="_blank"
                  >
                    <div id="zoomable-image-div">
                      <zoom-on-hover
                        :img-normal="
                          'https://smw.demo.itrooscloud.net/' +
                          record.brandImage
                        "
                      ></zoom-on-hover>
                    </div>
                  </a> -->

                  <a
                    style="text-decoration: none"
                    :href="
                      record.brandImage != null &&
                      record.brandImage != '' &&
                      record.brandImage != undefined
                        ? siteUrl + record.brandImage
                        : 'Javascript:void(0)'
                    "
                    target="_blank"
                  >
                    <span title="View Media">
                      <i
                        role="button"
                        style="color: #ea216c"
                        class="fas fa-download"
                      ></i>
                    </span>
                  </a>
                </td>
                 <td role="cell">
                  <b-form-checkbox
                    switch
                    v-model="record.isFeature"
                    @input="updateBrandFeaturedStatusState(record)"
                  >
                  </b-form-checkbox>
                </td>
                <td>
                  <span @click="editRecord(record)">
                    <i
                      role="button"
                      style="color: #ea216c"
                      class="fas fa-edit"
                    ></i>
                  </span>&nbsp;|&nbsp;

                  <span @click="deleteRecord(record.brandId)">
                    <i
                      role="button"
                      style="color: #ea216c"
                      class="far fa-trash-alt"
                    ></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--PAGINATION START-->
      <div class="row justify-content-between align-items-center">
        <div class="col-md-2">
          <div class="showPages">
            <select
              class="form-control"
              id="selClass"
              v-model="perPage"
              @change="getBrands()"
            >
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-8 d-flex justify-content-center">
          <div class="overflow-auto">
            <b-pagination
              v-model="page"
              :total-rows="rows"
              :per-page="perPage"
              limit="3"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
        </div>

        <div class="col-md-2">
          <input
            class="form-control search-box page-no-search"
            type="text"
            v-bind:placeholder="page"
            aria-label="search"
            v-model.number="pageNumOnSearch"
            style="height: 38px"
          />

          <button
            class="search-button btn btn-primary search page-no-search-btn"
            @click="search()"
          >
            GO
          </button>
        </div>
      </div>
      <!--/PAGINATION END-->
      <!--SPINNER-->
      <Spinner
        v-if="isLoading"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
      <!--/SPINNER-->
    </div>
    <!-- <AddClientModal /> -->
    <Toaster ref="toaster" />
    <EditPackageModal
      :recordToEdit="recordToEdit"
      v-if="recordToEdit != null"
    />
    <AddBrandModal />
    <DeleteModal
      :msgForModal="msgForModal"
      :apiEndPoint="apiEndPoint"
      :heading="deleteModalHeading"
      :entityId="recordToDelete"
      :isHttpPost="true"
    />
  </div>
</template>

<script>
import axios from "axios";
import Toaster from "../../common/pages/toaster.vue";
// import config from '../config.js';
import Spinner from "vue-simple-spinner";
import AddBrandModal from "./modals/add-brand-modal.vue";
import DeleteModal from "../../common/modals/delete-modal.vue";
import EditPackageModal from "./modals/edit-brand-modal.vue";

export default {
  name: "brandsmanagement",
  data() {
    return {
      siteUrl:"https://smw-live.azurewebsites.net",
      moduleName: " Brands Management",
      brands: [],
      isLoading: false,
      recordToEdit: null,
      recordToDelete: null,
      msgForModal: null,
      apiEndPoint: null,
      deleteModalHeading: null,

      clients: null,

      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getBrands();
    },

    editRecord(comp) {
      this.recordToEdit = comp;
      setTimeout(() => {
        this.$bvModal.show("EditBrandModal");
      }, 100);
    },
    deleteRecord(id) {
      this.recordToDelete = id;
      this.msgForModal = "Confirm to delete !";
      this.apiEndPoint = "/Adds/DeleteBrand?id=";
      this.deleteModalHeading = "Delete";
      this.$bvModal.show("DeleteModal");
    },

    getBrands() {
      this.isLoading = true;
      axios.post("/Adds/getbrand", {
          PageSize: this.perPage,
          PageNumber: this.page,
          Text: this.filteredText,
        }).then((res) => {
        this.isLoading = false;
        console.log(res.data.data);
        if (res.data.status == "Success") {
          this.brands = res.data.data;
          this.rows = res.data.totalCount;
        } else if (res.data.status == -1) {
          this.$refs.toaster.showToast("Error", "danger", res.data.msg);
        } else {
          this.brands = null;
        }
      });
    },

    updateBrandFeaturedStatusState(record) {

      this.isLoading = true;

      const formData = new FormData();
      formData.append("BrandId", record.brandId);
      formData.append("BrandUrl", record.brandUrl);
      formData.append("IsFeature", record.isFeature);
      formData.append("BrandImage", record.brandImage);
      formData.append("BrandName", record.brandName);


      // console.log(req);
      axios.post("/Adds/UpdateBrands", formData).then((res) => {
        this.isLoading = false;
        if (res.data.status == "Success") {
          console.log("success");
          // this.rows = res.data.totalRecords;
        } else {
          this.$refs.toaster.showToast("Error", "danger", res.data.msg);
        }
      });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getBrands();
    },
  },
  created() {
    this.getBrands();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner,
    EditPackageModal,
    DeleteModal,
    Toaster,
    AddBrandModal,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
</style>
